import { theme } from "../../../constants/StyledComponents";
import styled from "styled-components";

export const StyledPageError = styled.div`
  background-color: ${theme.colors.purple_5};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & .error-not-desktop-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 40px;
  }

  & .error-not-desktop-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  & .error-not-desktop-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
  }

  & .error-not-desktop-message {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;
